import { ClientContext } from "common/utils";
const isCrowdManager = () => {
  return ClientContext._appName === "crowd-manager";
};
export const processLocaleData = data => {
  const defaultCountry = data.filter(country => {
    return country.default;
  });
  if (defaultCountry.length === 0) {
    defaultCountry.push(data[0]);
  }
  let defaultLocale = "en-GB";
  if (defaultCountry.length >= 0) {
    defaultLocale = defaultCountry[0];
    if (!isCrowdManager()) {
      defaultLocale.value = `${defaultLocale.languageCode}-${defaultLocale.countryCode}`;
    }
  }
  return {
    countryList: data,
    defaultLocale
  };
};
export const processRestrictedData = data => data.value;
export const processAiServiceProvidersData = data => {
  return {
    conversationSummaryAiServices: data.value.map(item => item.featureName === "conversationSummary" && {
      label: item.displayName,
      value: item.serviceName,
      serviceName: item.serviceName,
      enabled: item.enabled || false
    }).filter(value => value),
    responseCodeAiServices: data.value.map(item => item.featureName === "responseCode" && {
      label: item.displayName,
      value: item.serviceName,
      serviceName: item.serviceName,
      enabled: item.enabled || false
    }).filter(value => value),
    qualityReviewServices: data.value.map(item => {
      return item.featureName === "qualityReview" && {
        label: item.displayName,
        value: item.serviceName,
        serviceName: item.serviceName,
        systemPrompt: item.systemPrompt
      };
    }).filter(value => value),
    practiceQuestionServices: data.value.map(item => {
      return item.featureName === "practiceQuestionReview" && {
        label: item.displayName,
        value: item.serviceName,
        serviceName: item.serviceName,
        systemPrompt: item.systemPrompt
      };
    }).filter(value => value),
    respondServices: data.value.map(item => {
      return item.featureName === "respondNextDialogue" && {
        label: item.displayName,
        value: item.serviceName,
        serviceName: item.serviceName,
        systemPrompt: item.systemPrompt
      };
    }).filter(value => value),
    genericServices: Array.from(new Map(data.value.filter(item => item.featureName === "qualityReview" || item.featureName === "practiceQuestionReview").map(item => [item.serviceName, {
      label: item.serviceName,
      value: item.serviceName,
      serviceName: item.serviceName
    }])).values())
  };
};